// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".anchor_0ZjfJ:before{content:\"\";display:block;height:160px;margin:-160px 0 0;visibility:hidden;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"anchor": "anchor_0ZjfJ"
};
module.exports = ___CSS_LOADER_EXPORT___;
